import { z } from 'zod';
import { CurrenciesIsoCodes } from '../types/Currency';
import { BaseSchema } from './BaseSchema';
export var CreditCardSchema = BaseSchema.extend({
    brand: z.string(),
    displayableNumber: z.string(),
    holderName: z.string(),
    month: z.string(),
    year: z.string(),
    iuguId: z.string().optional(),
    stripeId: z.string().optional(),
    currency: z.nativeEnum(CurrenciesIsoCodes),
    customer: z.string()
});
